const DEBUG_NAMESPACE = '[InterveneChat]';

function isDebugEnabled() {
  try {
    if (typeof window !== 'undefined') {
      const flag = window.localStorage?.getItem('interveneChatDebug');
      if (flag === '0' || flag === 'false') return false;
      if (flag === '1' || flag === 'true') return true;
    }
  } catch {
    // Ignore storage access errors and fall back to NODE_ENV.
  }

  return process.env.NODE_ENV !== 'production';
}

export function chatDebug(eventName, payload = {}, level = 'debug') {
  if (!isDebugEnabled()) return;

  const method = console[level] ? level : 'debug';
  console[method](`${DEBUG_NAMESPACE} ${eventName}`, payload);
}

export function summarizeMessage(message) {
  if (!message) return null;

  return {
    id: message.id || message.msg_id || message.w_id || message.message_id,
    phone_number: message.phone_number,
    origin: message.origin,
    chat_type: message.chat_type,
    intervened_by: message.intervened_by,
    username: message.username,
    whatsapp_name: message.whatsapp_name,
    type: message.content?.type || message.type || message.message_type,
    text:
      message.content?.body?.text ||
      message.content?.text ||
      message.text ||
      message.message ||
      null,
    created_at: message.created_at,
    timestamp: message.timestamp,
  };
}

export function summarizeMessages(messages = [], limit = 5) {
  return messages.slice(0, limit).map(summarizeMessage);
}
